<template>
  <div class="page flex-col justify-end">
    <SiteHeader />
    <div class="block_1 flex-col">
      <!-- 首页轮播图 -->
      <div v-if="homeData.homeBanner && homeData.homeBanner.length > 0" class="banner-container">
        <img 
          v-for="banner in homeData.homeBanner" 
          :key="banner.id"
          :src="banner.image.replace(/`/g, '')"
          :alt="banner.title"
          class="banner-image"
        />
      </div>
    </div>
    <div class="section_5 flex-col">
      <div class="intro-brand-bg flex-col">
        <div class="group_30 flex-row">
          <div class="text-wrapper_1 flex-col"><span class="text_4">{{ homeData.homeGsjj?.title || '北京皓溶生物科技有限公司' }}</span></div>
          <span class="paragraph_1" v-html="homeData.homeGsjj?.content || ''"></span>
        </div>
        <transition name="brand-bg-fade" mode="out-in">
          <div 
            :key="brandStoryIndex" 
            class="group_4 flex-col" 
            :style="brandStoryBackgroundStyle"
            @mouseenter="stopBrandStoryTimer"
            @mouseleave="startBrandStoryTimer"
          >
          <div class="block_3 flex-col">
            <transition name="brand-story-fade" mode="out-in">
              <div :key="brandStoryIndex" class="brand-story-content flex-col">
                <span class="text_5">{{ currentBrandStory.title }}</span>
                <span class="text_6" v-html="currentBrandStory.content"></span>
              </div>
            </transition>
            <div class="brand-story-actions flex-col">
              <div class="box_8 flex-row justify-between">
                <button
                  class="image-wrapper_1 flex-col"
                  type="button"
                  :disabled="brandStoryIndex === 0"
                  aria-label="上一条"
                  @click="prevBrandStory"
                >
                  <img
                    class="image_2"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng499159258333cc819233e3b19f8f18dd0aa01d023b77313b292520334d8de5dc.png"
                  />
                </button>
                <button
                  class="image-wrapper_2 flex-col"
                  type="button"
                  :disabled="brandStoryIndex === brandStoryItems.length - 1"
                  aria-label="下一条"
                  @click="nextBrandStory"
                >
                  <img
                    class="image_3"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPnge46a1ae3add126a5abb7c04f3ced9b49eb7daf84a043ae8370c42be9e2450512.png"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        </transition>
        <div class="group_31 brand-dots flex-row">
          <span
            v-for="(item, index) in brandStoryItems"
            :key="item.title + index"
            class="brand-dot"
            :class="index === brandStoryIndex ? 'brand-dot--active' : 'brand-dot--inactive'"
            @click="setBrandStory(index)"
          />
        </div>
      </div>
      <div class="text-wrapper_2 flex-col"><span class="text_7">发展历程</span></div>
      <span class="text_8">自1998年立项研发至今，我们始终专注于生物医药领域的创新探索与技术突破：</span>
      <div class="group_32 flex-row" @mouseenter="stopTimelineTimer" @mouseleave="startTimelineTimer">
        <div class="text-group_6 timeline-years flex-col">
          <span
            v-for="item in timelineDisplayItems"
            :key="item.year + '-' + item.originalIndex"
            class="timeline-year"
            :class="item.originalIndex === timelineIndex ? 'timeline-year--active' : 'timeline-year--inactive'"
            @click="setTimeline(item.originalIndex)"
          >
            {{ item.year }}
          </span>
        </div>
        <div class="timeline-controls flex-col">
          <button
            class="timeline-control timeline-control--up"
            type="button"
            :disabled="timelineIndex === 0"
            aria-label="上一条"
            @click="prevTimeline"
          />
          <button
            class="timeline-control timeline-control--down"
            type="button"
            :disabled="timelineIndex === timelineItems.length - 1"
            aria-label="下一条"
            @click="nextTimeline"
          />
        </div>
        <div class="box_9 flex-col justify-between">
          <transition name="brand-story-fade" mode="out-in">
            <div :key="timelineIndex" class="timeline-content flex-col">
              <div class="group_12 flex-col" :style="timelineImageStyle"></div>
              <span class="text_12">{{ currentTimeline.caption }}</span>
            </div>
          </transition>
        </div>
      </div>
      <div class="group_13 flex-col">
        <span class="text_13">联系我们</span>
        <span class="text_14" v-html="homeData.homeLxwm?.content || ''"></span>
        <div class="box_4 flex-row">
          <div class="contact-card flex-row">
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng2839a3210037228a3baee393941e3293313e066f2d8b0f45eaa1cc26e5b368fc.png"
              />
            </div>
            <div class="text-wrapper_12 flex-col justify-between">
              <span class="text_15">商务垂询</span>
              <span class="text_16">{{ homeData.homeLxwm?.email || 'contact&#64;haorongshengwu.com' }}</span>
            </div>
          </div>
          <div class="contact-card flex-row">
            <div class="image-wrapper_5 flex-col">
              <img
                class="label_2"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngc28d060a0f3303a20e6c53ae89f52b996425049c403726c4662dc845bf35efd3.png"
              />
            </div>
            <div class="text-wrapper_13 flex-col justify-between">
              <span class="text_17">公司地址</span>
              <span class="text_18">{{ homeData.homeLxwm?.address || '中国&nbsp;·&nbsp;北京市东城区富华大厦D座' }}</span>
            </div>
          </div>
        </div>
        <span class="text_19">隐私提示：您提供的信息将被严格保密，仅用于必要的业务沟通。</span>
      </div>
    </div>
    <div class="privacy-footer-gap">
      <SiteFooter variant="home" />
    </div>
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'HomePage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      homeData: {
        homeBanner: [],
        homeGsjj: {},
        homeLxwm: {},
        homePpgs: [],
        homeFzlc: []
      },
      brandStoryIndex: 0,
      brandStoryTimer: null,
      brandStoryItems: [],
      timelineIndex: 0,
      timelineTimer: null,
      timelineItems: []
    };
  },
  computed: {
    currentBrandStory() {
      return this.brandStoryItems[this.brandStoryIndex] || {};
    },
    brandStoryBackgroundStyle() {
      const image = this.currentBrandStory.backgroundImage;
      if (!image) return {};
      return {
        backgroundImage: `url(${image})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      };
    },
    currentTimeline() {
      return this.timelineItems[this.timelineIndex] || {};
    },
    timelineImageStyle() {
      const image = this.currentTimeline.image;
      if (!image) return {};
      return {
        backgroundImage: `url(${image})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      };
    },
    timelineDisplayItems() {
      const items = this.timelineItems || [];
      if (!items.length) return [];
      const startIndex = ((this.timelineIndex % items.length) + items.length) % items.length;
      return items
        .slice(startIndex)
        .concat(items.slice(0, startIndex))
        .map((item, offset) => ({
          ...item,
          originalIndex: (startIndex + offset) % items.length
        }));
    }
  },
  methods: {
    async fetchHomeData() {
      try {
        const response = await fetch('/api/pc/index');
        const data = await response.json();
        if (data.code === 1) {
          this.homeData = data.data;
          this.replaceImageDomain();
          this.updateBrandStoryItems();
          this.updateTimelineItems();
        }
      } catch (error) {
        console.error('Failed to fetch home data:', error);
      }
    },
    replaceImageDomain() {
      if (!this.homeData) return;
      
      const replaceDomain = (obj) => {        
        if (!obj) return;
        if (obj.image) {
          obj.image = obj.image.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
        if (obj.content) {
          obj.content = obj.content.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
        if (obj.abstract) {
          obj.abstract = obj.abstract.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
      };
      
      if (this.homeData.homeBanner) {
        this.homeData.homeBanner.forEach(replaceDomain);
      }
      if (this.homeData.homePpgs) {
        this.homeData.homePpgs.forEach(replaceDomain);
      }
      if (this.homeData.homeLc) {
        this.homeData.homeLc.forEach(replaceDomain);
      }
    },
    updateBrandStoryItems() {
      this.brandStoryItems = (this.homeData.homePpgs || []).map(item => ({
        title: item.title,
        content: item.abstract || item.content || '品牌故事内容',
        backgroundImage: item.image.replace(/`/g, '')
      }));
    },
    updateTimelineItems() {
      this.timelineItems = (this.homeData.homeFzlc || []).map(item => ({
        year: item.title.trim(),
        caption: item.abstract.trim(),
        image: item.image.replace(/`/g, '')
      }));
    },
    startBrandStoryTimer() {
      this.stopBrandStoryTimer();
      this.brandStoryTimer = setInterval(() => {
        if (this.brandStoryItems.length <= 1) return;
        this.brandStoryIndex = (this.brandStoryIndex + 1) % this.brandStoryItems.length;
      }, 50000);
    },
    stopBrandStoryTimer() {
      if (this.brandStoryTimer) {
        clearInterval(this.brandStoryTimer);
        this.brandStoryTimer = null;
      }
    },
    resetBrandStoryTimer() {
      this.startBrandStoryTimer();
    },
    startTimelineTimer() {
      this.stopTimelineTimer();
      this.timelineTimer = setInterval(() => {
        if (this.timelineItems.length <= 1) return;
        this.timelineIndex = (this.timelineIndex + 1) % this.timelineItems.length;
      }, 50000);
    },
    stopTimelineTimer() {
      if (this.timelineTimer) {
        clearInterval(this.timelineTimer);
        this.timelineTimer = null;
      }
    },
    resetTimelineTimer() {
      this.startTimelineTimer();
    },
    setBrandStory(index) {
      if (index < 0 || index >= this.brandStoryItems.length) return;
      this.brandStoryIndex = index;
      this.resetBrandStoryTimer();
    },
    prevBrandStory() {
      if (this.brandStoryIndex <= 0) return;
      this.brandStoryIndex -= 1;
      this.resetBrandStoryTimer();
    },
    nextBrandStory() {
      if (this.brandStoryIndex >= this.brandStoryItems.length - 1) return;
      this.brandStoryIndex += 1;
      this.resetBrandStoryTimer();
    },
    setTimeline(index) {
      if (index < 0 || index >= this.timelineItems.length) return;
      this.timelineIndex = index;
      this.resetTimelineTimer();
    },
    prevTimeline() {
      if (this.timelineIndex <= 0) return;
      this.timelineIndex -= 1;
      this.resetTimelineTimer();
    },
    nextTimeline() {
      if (this.timelineIndex >= this.timelineItems.length - 1) return;
      this.timelineIndex += 1;
      this.resetTimelineTimer();
    }
  },
  mounted() {
    this.fetchHomeData();
    this.startBrandStoryTimer();
    this.startTimelineTimer();
  },
  beforeDestroy() {
    this.stopBrandStoryTimer();
    this.stopTimelineTimer();
  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />
<style scoped>
.banner-container {
  width: 100%;
  overflow: hidden;
}
.banner-image {
  width: 100%;
  height: auto;
  display: block;
}
/* 确保样式能正确应用到v-html渲染的内容 */
.text_6 >>> p {
  margin: 0;
  padding: 0;
  line-height: 1.5;
}
</style>
